import React, { useEffect, useState } from 'react'
import { Grid, Popper } from '@material-ui/core'
import axios from 'axios'
import Autocomplete from '@material-ui/lab/Autocomplete'

import { useStyles, CssTextField } from './classes'

export default function SearchItems({ setFieldValue, dialogOpen }) {
  const classes = useStyles()
  const [results, setResults] = useState([])
  const [open, setOpen] = useState(false)
  const [inputValue, setInputValue] = useState('')

  useEffect(() => {
    loadSearchItemsList()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  //load restaurants and tags
  const loadSearchItemsList = async () => {
    try {
      let { data } = await axios.get('/search')
      setResults(data)
    } catch (error) {
      dialogOpen(true)
    }
  }

  const PopperMy = function (props) {
    return <Popper {...props} placement='none' />
  }

  return (
    <Grid item xs={12} sm={11} md={11} lg={12} className={classes.gapSpace}>
      <Autocomplete
        id='free-solo-demo'
        freeSolo
        open={open}
        onOpen={() => {
          if (inputValue) {
            setOpen(true)
          }
        }}
        onClose={() => setOpen(false)}
        inputValue={inputValue}
        onInputChange={(e, value, reason) => {
          setInputValue(value)

          if (!value) {
            setOpen(false)
          }
        }}
        PopperComponent={PopperMy}
        autoComplete
        includeInputInList
        filterSelectedOptions
        defaultValue={{
          id: '',
          name: '',
          type: '',
        }}
        size='small'
        onChange={(event, newValue) => {
          if (newValue) {
            const { id, type, name } = newValue

            setFieldValue('id', id)
            setFieldValue('type', type)
            setFieldValue('name', name)
          } else {
            setFieldValue('id', null)
            setFieldValue('type', null)
            setFieldValue('name', null)
          }
        }}
        options={results}
        getOptionLabel={(option) => option.name}
        renderInput={(params) => (
          <CssTextField
            {...params}
            className={classes.Searchinput}
            placeholder='Restaurant, Food'
            variant='outlined'
            id='custom-css-outlined-input'
            defaultValue
          />
        )}
      />
    </Grid>
  )
}
